import React, { FC } from 'react';

import { StyleSheet, ViewProps } from 'react-native';

import { Box } from 'components/ui';
import { getDesignToken, primitive } from 'styles/constants';
interface RadioIndicatorProps extends ViewProps {
  isSelected: boolean;
  isDisabled?: boolean;
  marginTop?: '$2' | '$3_5';
}

export const RadioIndicator: FC<RadioIndicatorProps> = ({
  isSelected,
  isDisabled,
  marginTop,
  style,
  ...boxProps
}) => {
  return (
    <Box
      style={[
        styles.indicator,
        {
          backgroundColor: isDisabled
            ? getDesignToken('background-input-disabled')
            : getDesignToken('background-input'),
          borderColor: isSelected ? primitive.$bbqBrown : primitive.$greyTwo,
          borderWidth: isSelected ? 5 : 1,
        },
        marginTop === '$2' && styles.marginTop2,
        marginTop === '$3_5' && styles.marginTop3_5,
        style,
      ]}
      {...boxProps}
    />
  );
};

export default RadioIndicator;

const styles = StyleSheet.create({
  indicator: { borderRadius: 10, height: 20, width: 20 },
  marginTop2: { marginTop: 8 },
  marginTop3_5: { marginTop: 14 },
});
